import { render, staticRenderFns } from "./HeaderShell.vue?vue&type=template&id=327d11bc&scoped=true&"
import script from "./HeaderShell.vue?vue&type=script&lang=js&"
export * from "./HeaderShell.vue?vue&type=script&lang=js&"
import style0 from "./HeaderShell.vue?vue&type=style&index=0&id=327d11bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d11bc",
  null
  
)

export default component.exports